import React, {ReactElement} from 'react';
import {IElementStatusComponent} from '../../../incase-domain/elements/statusComponent';
import NobulaLogo from '../../../../assets/icons/NobulaLogo.svg';

interface ElementStatusComponentProps {
    element: IElementStatusComponent;
}
function ElementStatusComponent(props: ElementStatusComponentProps): ReactElement {
    const {element} = props;
    const {statusMainImage, statusLayout, mainImageWidthHeightRatio, font, statusParts} = element;

    function elementParts(
        parts: {
            text: string;
            image: string;
        }[]
    ): JSX.Element {
        return (
            <div className="u-flex u-flex-col u-h-evenly">
                {parts.map((part, index) => {
                    return (
                        <div className="u-flex" key={part.toString() + index}>
                            <div style={{width: '25%', maxWidth: '100%', margin: '0.25em'}}>
                                <img style={{objectFit: 'contain'}} src={part.image || NobulaLogo} alt="" />
                            </div>

                            <div
                                style={{fontSize: `${font.size || 2}em`, objectFit: 'contain', width: '50%', margin: '0.25em'}}
                                className="u-m--xs w-50"
                            >
                                {part.text}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    if (statusLayout === 0) {
        const center = statusParts.length > 0 ? Math.floor(statusParts.length / 2) : 0;

        const leftParts = statusParts.slice(0, center);
        const rightParts = statusParts.slice(center, statusParts.length);

        return (
            <div className="u-flex">
                {elementParts(leftParts)}
                <img
                    style={{width: '50%', maxWidth: '100%', objectFit: 'contain', height: `${100 * mainImageWidthHeightRatio}%`}}
                    src={statusMainImage}
                    alt=""
                />
                {elementParts(rightParts)}
            </div>
        );
    }
    if (statusLayout === 1) {
        return (
            <div className="u-flex">
                <img
                    style={{width: '50%', maxWidth: '100%', objectFit: 'contain', height: `${100 * mainImageWidthHeightRatio}%`}}
                    src={statusMainImage}
                    alt=""
                />
                {elementParts(statusParts)}
            </div>
        );
    }
    if (statusLayout === 2) {
        return (
            <div className="u-flex">
                {elementParts(statusParts)}
                <img
                    style={{width: '50%', maxWidth: '100%', objectFit: 'contain', height: `${100 * mainImageWidthHeightRatio}%`}}
                    src={statusMainImage}
                    alt=""
                />
            </div>
        );
    }

    return (
        <div>
            <img
                style={{width: '50%', maxWidth: '100%', objectFit: 'contain', height: `${100 * mainImageWidthHeightRatio}%`}}
                src={statusMainImage}
                alt="Status element main"
            />
        </div>
    );
}

export default ElementStatusComponent;
